import { render, staticRenderFns } from "./Datenschutz.vue?vue&type=template&id=89f21c40&scoped=true"
import script from "./Datenschutz.vue?vue&type=script&lang=js"
export * from "./Datenschutz.vue?vue&type=script&lang=js"
import style0 from "./Datenschutz.vue?vue&type=style&index=0&id=89f21c40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89f21c40",
  null
  
)

export default component.exports